import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

export default function OAuthCallback() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { login } = useAuthStore()

  useEffect(() => {
    const token = searchParams.get('token')
    const userParam = searchParams.get('user')
    const error = searchParams.get('error')

    if (error) {
      console.error('OAuth error:', error)
      navigate(`/login?error=${encodeURIComponent(error)}`)
      return
    }

    if (token) {
      try {
        // Parse user data if provided
        const user = userParam ? JSON.parse(decodeURIComponent(userParam)) : { email: 'OAuth User' }
        
        // Store auth in Zustand store
        login(user, token)
        
        // Redirect to dashboard
        navigate('/dashboard', { replace: true })
      } catch (err) {
        console.error('Failed to parse OAuth response:', err)
        navigate('/login?error=invalid_oauth_response')
      }
    } else {
      // No token, redirect to login
      navigate('/login?error=missing_token')
    }
  }, [searchParams, navigate, login])

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'rgb(var(--rgb-canvas))',
      color: 'var(--color-text)',
      fontFamily: 'Unbounded, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '3px solid rgb(var(--rgb-brand) / 0.2)',
          borderTopColor: 'rgb(var(--rgb-brand))',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1rem'
        }}></div>
        <p style={{ fontSize: '1.125rem', fontWeight: 600 }}>Connexion en cours...</p>
        <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)', marginTop: '0.5rem' }}>
          Vous allez être redirigé dans un instant
        </p>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}
